<h1>Auslieferung Grippeimpfstoffe 2025/26</h1>

<p class="mb-l">
  Sehr geehrtes Apothekenteam,</p>
 <p> wie bereits per E-Mail/Fax angekündigt, beginnen wir mit der Auslieferung der von Ihnen bei den Herstellern direkt bestellten Überweiser-Aufträge sowie der über unser Kundenportal vorbestellten Impfstoffe für die Grippeimpfstoff-Saison 2025/2026.
</p>
<mat-accordion>
  @for (preorder of preorders; track preorder) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title class="title red">
          {{ preorder.vendor }}
        </mat-panel-title>
      </mat-expansion-panel-header>
      <table mat-table [dataSource]="preorder.deliveries">
          <!-- PZN Column -->
          <ng-container matColumnDef="pzn">
            <th mat-header-cell *matHeaderCellDef>PZN</th>
            <td mat-cell *matCellDef="let element"> {{element.pzn}} </td>
          </ng-container>
          <ng-container matColumnDef="product_name">
            <th mat-header-cell *matHeaderCellDef>Artikelbezeichnung</th>
            <td mat-cell *matCellDef="let element"> {{element.product_name}} </td>
          </ng-container>
          <ng-container matColumnDef="comment">
            <th mat-header-cell *matHeaderCellDef>Anmerkungen</th>
            <td mat-cell *matCellDef="let element"> {{element.comment}} </td>
          </ng-container>
        <ng-container matColumnDef="delivery_date">
          <th mat-header-cell *matHeaderCellDef>Datum  Auslieferung</th>
          <td mat-cell *matCellDef="let element"> {{element.delivery_date | date: 'shortDate'}} </td>
        </ng-container>
          <ng-container matColumnDef="tour">
            <th mat-header-cell *matHeaderCellDef>Ausliefertour (Uhrzeit)</th>
            <td mat-cell *matCellDef="let element"> {{element.tour}} </td>
          </ng-container>

          <ng-container matColumnDef="qty">
            <th mat-header-cell *matHeaderCellDef>Liefermenge</th>
            <td mat-cell *matCellDef="let element"> {{element.qty}} </td>
          </ng-container>
<!--          <ng-container matColumnDef="remaining_qty">-->
<!--            <th mat-header-cell *matHeaderCellDef>noch offene Menge</th>-->
<!--            <td mat-cell *matCellDef="let element"> {{element.remaining_qty}} </td>-->
<!--          </ng-container>-->


        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </mat-expansion-panel>
  }
</mat-accordion>

<h3 class="mt-l">Wichtige Hinweise!</h3>
<p>Bitte gleichen Sie die angekündigten Liefermengen mit Ihrer Bestellung ab.<br>
  Aus organisatorischen Gründen kann es sich hierbei auch um Teillieferungen handeln.<br>
  Sonderwünsche hinsichtlich Teilmengenauslieferung bitten wir umgehend an <a class="link" href="mailto:impfstoffe@hagedastumpf.de">  impfstoffe@hagedastumpf.de</a> zu melden.<br>
  <strong>Bitte beachten Sie, dass Grippeimpfstoffe von der Retoure ausgeschlossen sind!</strong><br>
  Zudem bitten wir um schnelle Rückführung des Leergutes, indem Sie leeren Kühlwannen umgehend unseren Fahrer zur Abholung bereitstellen.</p>
<p>Mit freundlichen Grüßen</p>
<p>Impfstoff-Team<br>
  Hageda-Stumpf</p>
